import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';

export const noAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  const token = localStorageService.get('authentication');
  const userId = localStorageService.get('user_id');
  const inviteUserId = localStorageService.get('invite_user_id');

  if (token && userId ) {
    // If the user is already authenticated, redirect them to the dashboard or another route
    if(inviteUserId && inviteUserId !== userId){
      return true
    }
    router.navigate(['/dashboard']); // Redirect authenticated users
    return false;
  }

  return true; 
};

